module.exports = __webpack_public_path__ + "img/on-active.6c1032af.svg";